import * as React from 'react';
import prettyBytes from 'pretty-bytes';
import c from 'classnames';

import './style.scss';

type Props = {
  title: string;
  source: string;
  size: string;
  className?: string;
};

const DownloadButton: React.FC<Props> = (props) => {
  const {
    title,
    source,
    size,
    className,
  } = props;

  const classnames = c('DownloadButton', className);

  return (
    <div className={classnames}>
      {/* TODO: Place the icon as soon as it's available */}
      <div className="DownloadButton__icon" />
      <div className="DownloadButton__inner">
        <a className="DownloadButton__link" href={source}>
          {title}
        </a>
        <p className="DownloadButton__size body--small">{prettyBytes(Number(size))}</p>
      </div>
    </div>
  );
};

export default DownloadButton;
